import React from 'react';
import PropTypes from 'prop-types';
import { SimpleSelect } from 'react-selectize-advizr';
import AdvForm from '../../../CommonComponents/AdvForm';
import {
  simpleSelectDefaultValue,
  simpleSelectChangedToNonNull,
} from '../../../Profile/Accounts_react/AccountsUtils';
import { isNumeric, createCustomPropType, isUuid } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';

const View = ({
  clientId,
  title,
  groupTitle,
  areOptionsLoaded,
  goalId,
  whatIfType,
  storeData,
  hasSpouse,
  principalName,
  spouseName,
  survivorEmploymentIncomeOptions,
  principalSurvivorEmploymentIncome,
  spouseSurvivorEmploymentIncome,
}) => (
  <div className="what-ifs-layout-content">
    <h4 className="what-if-group-title">{groupTitle}</h4>
    <AdvForm>
      <ValidationErrors clientId={clientId} />
      <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
        <li className="what-ifs-form-field">
          <h5 className="what-if-title">{title}</h5>
        </li>
        <li className="what-ifs-form-field">
          <label
            className="what-ifs-insurance-label"
            htmlFor="PrincipalSurvivorEmploymentIncome"
          >
            <span className="what-ifs-label-text">{principalName}</span>
            <br />
            <SimpleSelect
              id="PrincipalSurvivorEmploymentIncome"
              className="what-ifs-simple-select"
              value={simpleSelectDefaultValue(
                survivorEmploymentIncomeOptions,
                principalSurvivorEmploymentIncome,
              )}
              onValueChange={simpleSelectChangedToNonNull(
                clientId,
                storeData(goalId, whatIfType),
                'WhatIf.PrincipalSurvivorEmploymentIncome',
              )}
              options={survivorEmploymentIncomeOptions}
            />
          </label>
        </li>
        {hasSpouse && (
          <li className="what-ifs-form-field">
            <label
              className="what-ifs-insurance-label"
              htmlFor="SpouseSurvivorEmploymentIncome"
            >
              <span className="what-ifs-label-text">{spouseName}</span>
              <br />
              <SimpleSelect
                id="SpouseSurvivorEmploymentIncome"
                className="what-ifs-simple-select"
                value={simpleSelectDefaultValue(
                  survivorEmploymentIncomeOptions,
                  spouseSurvivorEmploymentIncome,
                )}
                onValueChange={simpleSelectChangedToNonNull(
                  clientId,
                  storeData(goalId, whatIfType),
                  'WhatIf.SpouseSurvivorEmploymentIncome',
                )}
                options={survivorEmploymentIncomeOptions}
              />
            </label>
          </li>
        )}
      </ul>
    </AdvForm>
  </div>
);
View.defaultProps = {
  title: '',
  groupTitle: '',
  spouseName: '',
  spouseSurvivorEmploymentIncome: 100,
};

View.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  whatIfType: PropTypes.number.isRequired,
  storeData: PropTypes.func.isRequired,
  hasSpouse: PropTypes.bool.isRequired,
  principalName: PropTypes.string.isRequired,
  spouseName: PropTypes.string,
  spouseSurvivorEmploymentIncome: PropTypes.number,
  survivorEmploymentIncomeOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  principalSurvivorEmploymentIncome: PropTypes.number.isRequired,
};

export default View;
